import React, { useContext, useState } from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import PanelPopup from '../_partials/PanelPopup';
import DesktopLayout from '../_partials/DesktopLayout';
import MonetizationStrip from '../../MonetizationStrip';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import DesktopAdhesion from '@wix/da-ads/pkg/adunits/anon/DesktopAdhesion';
import UserDesktopAdhesion from '@wix/da-ads/pkg/adunits/user/DesktopAdhesion';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import ErrorBoundary from '../../ErrorBoundary';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import { useSelector } from 'react-redux';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './DesktopDeviationPage.scss';
const DesktopDeviationPage = ({ deviation  })=>{
    const { adsEnabled , isLoggedIn  } = useContext(SessionContext);
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const isLite = useFlag('ads_loggedin_lite') && isLoggedIn;
    // we'll force a re-render of the page when a countdown in the offer banner of the monetization strip
    // reaches 0 (onAdoptableSaleEnd). This will update the actionbar to change from the 'make an offer'
    // button to the 'view offers' button to show the sale is over
    const [hasAdoptionEnded, setHasAdoptionEnded] = useState(false);
    return /*#__PURE__*/ React.createElement(DesktopLayout, {
        deviation: deviation,
        adContent: adsEnabled && !isLite && /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "DesktopAdhesion"
        }, /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
            anon: DesktopAdhesion,
            user: UserDesktopAdhesion,
            safety: adSafety
        })),
        stageContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ArtStage, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['monetization-strip-wrapper']
        }, /*#__PURE__*/ React.createElement(MonetizationStrip, {
            className: s['monetization-strip'],
            deviation: deviation,
            onAdoptableSaleEnd: ()=>setHasAdoptionEnded(true)
        })), /*#__PURE__*/ React.createElement(ActionBar, {
            // maintain a key so we can force a re-render
            key: `actionbar-${hasAdoptionEnded}`,
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(PanelPopup, {
            deviation: deviation,
            actionBarType: "primary",
            className: s['large-popover-uplifted']
        })),
        metaContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Details, {
            contentClassName: s['details'],
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
            user: deviation.author
        })),
        withSecondaryActionBar: [
            DeviationTypes.JOURNAL
        ].includes(getDeviationType(deviation))
    });
};
DesktopDeviationPage.displayName = 'DesktopDeviationPage';
export default DesktopDeviationPage;
